<template>
  <div class="app_page">
    <serviceQrCode :isFengChannel="channelSystem == 4" :userId="$route.query.userId" />
    <div class="policy_info">
      <p class="title_">
        投保人信息
      </p>
      <div class="item_">
        <span class="nowrap_">投保人姓名</span>
        <div>
          <input :class="checkedData.policyHolderName ? 'alert_' : ''" type="text"
               placeholder="请输入姓名" v-model="policyFormData.holderName" @blur="changeFieldName($event,'policyHolderName')">
          <p class="empty_" v-if="checkedData.policyHolderName">姓名不能为空</p>
        </div>
      </div>
      <div class="item_">
        <span class="nowrap_">证件类型</span>
        <span class="red_">身份证</span>
      </div>
      <div class="item_">
        <span class="nowrap_">证件号码</span>
        <div>
          <input type="text" :class="checkedData.policyIdNumber ? 'alert_' : ''"
               placeholder="请输入证件号码" v-model="policyFormData.idNumber" @blur="changeFieldName($event,'policyIdNumber')">
               
               <p class="empty_ red_c" v-if="checkedData.policyIdNumber">{{policyIdNumberPlaceHolder}}</p>
        </div>
      </div>
      <div class="item_">
        <span class="nowrap_">国籍</span>
        <span class="red_">中国</span>
      </div>
      <div class="item_">
        <span class="nowrap_">居住省市</span>
        <div>
          <div class="flex_">
          <input type="text" :class="checkedData.policyAddressName ? 'alert_' : ''"
               placeholder="请选择所在地区" readonly @click="showAddressPicker" v-model="policyFormData.addressName" @blur="changeFieldName($event,'policyAddressName')">
               <img class="arrow_right" src="../../assets/image/yf/arrow-right.png" alt="二维码"></div>
               <p class="empty_" v-if="checkedData.policyAddressName">地区不能为空</p>
          
        </div>
      </div>
      <div class="item_">
        <span class="nowrap_" style="flex: 1;text-align:left;">详细地址</span>
        <div style="flex: 3;">
          <input style="width: 100%;" type="text" :class="checkedData.policyAddress ? 'alert_' : ''"
               placeholder="请详尽到街道和门牌号（汉字数不低于6个）" v-model="policyFormData.address" @blur="changeFieldName($event,'policyAddress')">
               <p class="empty_" v-if="checkedData.policyAddress">详细地址不能为空</p>
        </div>
      </div>
      <div class="item_">
        <span class="nowrap_">邮政编码</span>
        <div>
          <input type="text" :class="checkedData.policyPostCode ? 'alert_' : ''"
               placeholder="请输入邮政编码" v-model="policyFormData.postCode" @blur="changeFieldName($event,'policyPostCode')">
               <p class="empty_ red_c" v-if="checkedData.policyPostCode">{{policyIdPostCodePlaceHolder}}</p>
        </div>
      </div>
      <div class="item_">
        <span class="nowrap_">手机号码</span>
        <div>
          <input type="text" :class="checkedData.policyTelephone ? 'alert_' : ''"
               placeholder="请输入本人手机号码" v-model="policyFormData.telephone" @blur="changeFieldName($event,'policyTelephone')">
               <p class="empty_ red_c" v-if="checkedData.policyTelephone">{{policyIdPhonePlaceHolder}}</p>
        </div>
      </div>
      <div class="item_">
        <span class="nowrap_">电子邮箱</span>
        <div>
          <input type="text" :class="checkedData.policyEmail ? 'alert_' : ''"
               placeholder="请输入本人邮箱" v-model="policyFormData.email" @blur="changeFieldName($event,'policyEmail')">
               <p class="empty_ red_c" v-if="checkedData.policyEmail">{{policyIdEmailPlaceHolder}}</p>
        </div>
      </div>
      <div class="item_">
        <span class="nowrap_">职业</span>
        <div>
          <div class="flex_">
          <input style="width: 250px;" type="text" :class="checkedData.policyOccupationNameSh ? 'alert_' : ''" readonly
               placeholder="请选择职业" @click="showOccupationPicker" v-model="policyFormData.occupationNameSh" @blur="changeFieldName($event,'policyOccupationNameSh')">
               <img class="arrow_right" src="../../assets/image/yf/arrow-right.png" alt="二维码"></div>
               <p class="empty_" v-if="checkedData.policyOccupationNameSh">职业不能为空</p>
        </div>
      </div>
      <div class="item_">
        <span class="nowrap_">身高（cm）</span>
        <div>
          <input type="text" :class="checkedData.policyHeight ? 'alert_' : ''"
               placeholder="请输入本人身高" v-model="policyFormData.height" @blur="changeFieldName($event,'policyHeight')">
               <p class="empty_ red_c" v-if="checkedData.policyHeight">身高不能为空</p>
        </div>
      </div>
      <div class="item_">
        <span class="nowrap_">体重（kg）</span>
        <div>
          <input type="text" :class="checkedData.policyWeight ? 'alert_' : ''"
               placeholder="请输入本人体重" v-model="policyFormData.weight" @blur="changeFieldName($event,'policyWeight')">
               <p class="empty_ red_c" v-if="checkedData.policyWeight">体重不能为空</p>
        </div>
      </div>
      <div class="item_">
        <span class="nowrap_">年收入（万）</span>
        <div>
          <input type="text" :class="checkedData.policyIncome ? 'alert_' : ''"
               placeholder="请输入本人年收入" v-model="policyFormData.annualIncome" @blur="changeFieldName($event,'policyIncome')">
               <p class="empty_ red_c" v-if="checkedData.policyIncome">年收入不能为空</p>
        </div>
      </div>
    </div>
    <div class="bottom_">
      <div class="insured_info">
        <p class="title_">
          被投保人信息
        </p>
        <div class="item_">
          <span class="nowrap_" style="flex: 1;">是被保人的</span>
          <div style="flex: 3;display:flex;justify-content: space-around;">
            <span class="relate_item" :class="activeRelateIndex == index ? 'active': 'grey_'" v-for="(item,index) in relateList" :key="item.value" @click="changeRelate(index,item)">{{item.text}}</span>
          </div>
        </div>
        <div class="relate_" v-if="!isSelf">
          <div class="item_">
            <span class="nowrap_">被保人姓名</span>
            <div>
              <input type="text" :class="checkedData.insuredName ? 'alert_' : ''"
                   placeholder="请输入姓名" v-model="insuranceFormData.insuredName" @blur="changeFieldName($event,'insuredName')">
                   <p class="empty_" v-if="checkedData.insuredName">姓名不能为空</p>
            </div>
          </div>
          <div class="item_">
            <span class="nowrap_">证件类型</span>
            <span class="red_">身份证</span>
          </div>
          <div class="item_">
            <span class="nowrap_">证件号码</span>
            <div>
              <input type="text" :class="checkedData.insuredIdNumber ? 'alert_' : ''"
                   placeholder="请输入证件号码" v-model="insuranceFormData.insuredIdNumber" @blur="changeFieldName($event,'insuredIdNumber')">
                   <p class="empty_ red_c" v-if="checkedData.insuredIdNumber">{{insuranceNumberPlaceHolder}}</p>
            </div>
          </div>
          <div class="item_">
            <span class="nowrap_">国籍</span>
            <span class="red_">中国</span>
          </div>
          <div class="item_">
            <span class="nowrap_">居住省市</span>
            <div>
              <div class="flex_">
              <input type="text" :class="checkedData.insuredAddressName ? 'alert_' : ''"
                   placeholder="请选择所在地区" @click="showInsuranAddressPicker" v-model="insuranceFormData.addressName" @blur="changeFieldName($event,'insuredAddressName')">
                   <img class="arrow_right" src="../../assets/image/yf/arrow-right.png" alt="二维码"></div>
                   <p class="empty_" v-if="checkedData.insuredAddressName">地区不能为空</p>
            </div>
          </div>
          <div class="item_">
            <span class="nowrap_" style="flex: 1;text-align:left;">详细地址</span>
            <div style="flex: 3;">
              <input type="text" style="width: 100%;" :class="checkedData.insuredAddress ? 'alert_' : ''"
                   placeholder="请详尽到街道和门牌号（汉字数不低于6个）" v-model="insuranceFormData.address" @blur="changeFieldName($event,'insuredAddress')">
                   <p class="empty_" v-if="checkedData.insuredAddress">请输入详细地址</p>
            </div>
          </div>
          <div class="item_">
            <span class="nowrap_">邮政编码</span>
            <div>
              <input type="text" :class="checkedData.insuredPostCode ? 'alert_' : ''"
                   placeholder="请输入邮政编码" v-model="insuranceFormData.postCode" @blur="changeFieldName($event,'insuredPostCode')">
                   <p class="empty_ red_c" v-if="checkedData.insuredPostCode">{{insurancePostCodePlaceHolder}}</p>
            </div>
          </div>
          <div class="item_">
            <span class="nowrap_">手机号码</span>
            <div>
              <input type="text" :class="checkedData.insuredTelephone ? 'alert_' : ''"
                   placeholder="请输入本人手机号码" v-model="insuranceFormData.telephone" @blur="changeFieldName($event,'insuredTelephone')">
                   <p class="empty_ red_c" v-if="checkedData.insuredTelephone">{{insurancePhonePlaceHolder}}</p>
            </div>
          </div>
          <div class="item_">
            <span class="nowrap_">电子邮箱</span>
            <div>
              <input type="text" :class="checkedData.insuredEmail ? 'alert_' : ''"
                   placeholder="请输入本人邮箱" v-model="insuranceFormData.email" @blur="changeFieldName($event,'insuredEmail')">
                   <p class="empty_ red_c" v-if="checkedData.insuredEmail">{{insuranceEmailPlaceHolder}}</p>

            </div>
          </div>
          <div class="item_">
            <span class="nowrap_">职业</span>
            <div>
              <div class="flex_">
              <input style="width: 250px;" type="text" :class="checkedData.insuredOccupationNameSh ? 'alert_' : ''"
                   placeholder="请选择职业" readonly @click="showInsuranOccupationPicker" v-model="insuranceFormData.occupationNameSh" @blur="changeFieldName($event,'insuredOccupationNameSh')">
                   <img class="arrow_right" src="../../assets/image/yf/arrow-right.png" alt="二维码"></div>
                   <p class="empty_" v-if="checkedData.insuredOccupationNameSh">职业不能为空</p>
            </div>
          </div>
          <div class="item_">
            <span class="nowrap_">身高（cm）</span>
            <div>
              <input type="text" :class="checkedData.insuredHeight ? 'alert_' : ''"
                  placeholder="请输入本人身高" v-model="insuranceFormData.height" @blur="changeFieldName($event,'insuredHeight')">
                  <p class="empty_ red_c" v-if="checkedData.insuredHeight">身高不能为空</p>
            </div>
          </div>
          <div class="item_">
            <span class="nowrap_">体重（kg）</span>
            <div>
              <input type="text" :class="checkedData.insuredWeight ? 'alert_' : ''"
                  placeholder="请输入本人体重" v-model="insuranceFormData.weight" @blur="changeFieldName($event,'insuredWeight')">
                  <p class="empty_ red_c" v-if="checkedData.insuredWeight">体重不能为空</p>
            </div>
          </div>
          <div class="item_">
            <span class="nowrap_">年收入（万）</span>
            <div>
              <input type="text" :class="checkedData.insuredIncome ? 'alert_' : ''"
                  placeholder="请输入本人年收入" v-model="insuranceFormData.annualIncome" @blur="changeFieldName($event,'insuredIncome')">
                  <p class="empty_ red_c" v-if="checkedData.insuredIncome">年收入不能为空</p>
            </div>
          </div>
        </div>
      </div>
      <div class="benefic_info">
        <p class="title_">
          受益人信息
        </p>
        <div class="item_">
          <span class="nowrap_">受益人</span>
          <span class="red_">法定受益人</span>
        </div>
      </div>
      <div class="insurance_type_info">
        <p class="title_">
          银行卡信息
        </p>
        <div class="item_">
          <span class="nowrap_">开户银行</span>
          <div>
            <div class="flex_">
            <input type="text" :class="checkedData.bankName ? 'alert_' : ''"
                 placeholder="开户银行" readonly @click="showBankPicker" v-model="policyFormData.bankName" @blur="changeFieldName($event,'bankName')">
                 <img class="arrow_right" src="../../assets/image/yf/arrow-right.png" alt="二维码"></div>
                 <p class="empty_" v-if="checkedData.bankName">请选择开户银行</p>
          </div>
        </div>
        <div class="item_">
          <span class="nowrap_">持卡人姓名</span>
          <div>
            <input type="text" :class="checkedData.receiverName ? 'alert_' : ''"
                 placeholder="请输入姓名" v-model="policyFormData.receiverName" @blur="changeFieldName($event,'receiverName')">
                 <p class="empty_" v-if="checkedData.receiverName">持卡人姓名不能为空</p>
          </div>
        </div>
        <div class="item_">
          <span class="nowrap_">银行卡号</span>
          <div>
            <input type="text" :class="checkedData.bankCardCode ? 'alert_' : ''"
                 placeholder="请输入银行卡号" v-model="policyFormData.bankCardCode" @blur="changeFieldName($event,'bankCardCode')">
                 <p class="empty_" v-if="checkedData.bankCardCode">银行卡号不能为空</p>
          </div>
        </div>
        <div class="item_">
          <span class="nowrap_">预留手机号</span>
          <div>
            <input type="text" :class="checkedData.reservedPhone ? 'alert_' : ''"
                 placeholder="请输入预留手机号" v-model="policyFormData.reservedPhone" @blur="changeFieldName($event,'reservedPhone')">
                 <p class="empty_" v-if="checkedData.reservedPhone">{{reservedPhonePlaceHolder}}</p>
          </div>
        </div>
        <div class="bank_card">
          <cube-upload v-model="bankFiles"
          @file-submitted="(file) => submitted(file,'bankFiles')"
          @file-error="errHandler"
          :processFile="processFile">
            <cube-upload-btn :multiple="false">
              <div class="card_"
                   v-if="bankFiles.length == 0">
                <img src="../../assets/image/yf/bank_card.png"
               alt="二维码">
              </div>
              <div v-else class="img_box">
                <img class="delete" src="../../assets/image/yf/delete.png" alt="" @click="deleteImg('policyFormData', 'bankCardPicture', 'bankFiles')">
                <img class="img_" :src="policyFormData.bankCardPicture" />
              </div>
            </cube-upload-btn>
          </cube-upload>
          <p>点击上传银行卡正面</p>
        </div>
      </div>
      <div class="id_card_info">
        <p class="title_">
          身份证上传
        </p>
        <div class="id_card_upload_box">
          <div class="upload_">
            <div class="box_">
              <cube-upload v-model="policyFaceFiles"
              @file-submitted="(file) => submitted(file,'policyFaceFiles','face')"
              @file-error="errHandler"
              :processFile="processFile">
                <cube-upload-btn :multiple="false">
                  <div class=""
                      v-if="policyFaceFiles.length == 0">
                    <p>投保人证件正面</p>
                    <img src="../../assets/image/yf/id_card_front.png"
                  alt="二维码">
                  </div>
                  <div class="img_box" v-else>
                    <p>投保人证件正面</p>
                    <img class="delete" src="../../assets/image/yf/delete.png" alt="" @click="deleteImg('policyFormData', 'idCardFacePicture', 'policyFaceFiles')">
                    <img class="img_"
                      :src="policyFormData.idCardFacePicture" />
                  </div>
                </cube-upload-btn>
              </cube-upload>
            </div>
            <div class="box_">
              <cube-upload v-model="policyBackFiles"
              @file-submitted="(file) => submitted(file,'policyBackFiles','back')"
              @file-error="errHandler"
              :processFile="processFile">
                <cube-upload-btn :multiple="false">
                  <div class=""
                      v-if="policyBackFiles.length == 0">
                    <p>投保人证件反面</p>
                    <img src="../../assets/image/yf/id_card_back.png"
                  alt="二维码">
                  </div>
                  <div class="img_box" v-else>
                    <p>投保人证件反面</p>
                    <img class="delete" src="../../assets/image/yf/delete.png" alt="" @click="deleteImg('policyFormData', 'idCardBackPicture', 'policyBackFiles')">
                    <img class="img_"
                      :src="policyFormData.idCardBackPicture" />
                  </div>
                </cube-upload-btn>
              </cube-upload>
            </div>
          </div>
          <div class="upload_" v-if="!isSelf">
            <div class="box_">
              <cube-upload v-model="insuranceFaceFiles"
              @file-submitted="(file) => submitted(file,'insuranceFaceFiles','face')"
              @file-error="errHandler"
              :processFile="processFile">
                <cube-upload-btn :multiple="false">
                  <div class=""
                      v-if="insuranceFaceFiles.length == 0">
                    <p>被投保人证件正面</p>
                    <img src="../../assets/image/yf/id_card_front.png"
                  alt="二维码">
                  </div>
                  <div class="img_box" v-else>
                    <p>被投保人证件正面</p>
                    <img class="delete" src="../../assets/image/yf/delete.png" alt="" @click="deleteImg('insuranceFormData', 'idCardFacePicture', 'insuranceFaceFiles')">
                    <img class="img_"
                      :src="insuranceFormData.idCardFacePicture" />
                  </div>
                  
                </cube-upload-btn>
              </cube-upload>
            </div>
            <div class="box_">
              <cube-upload v-model="insuranceBackFiles"
              @file-submitted="(file) => submitted(file,'insuranceBackFiles','back')"
              @file-error="errHandler"
              :processFile="processFile">
                <cube-upload-btn :multiple="false">
                  <div class=""
                      v-if="insuranceBackFiles.length == 0">
                    <p>被投保人证件反面</p>
                    <img src="../../assets/image/yf/id_card_back.png"
                  alt="二维码">
                  </div>
                  <div v-else class="img_box">
                    <p>被投保人证件反面</p>
                    <img class="delete" src="../../assets/image/yf/delete.png" alt="" @click="deleteImg('insuranceFormData', 'idCardBackPicture', 'insuranceBackFiles')">
                    <img class="img_"
                      :src="insuranceFormData.idCardBackPicture" />
                  </div>
                  
                </cube-upload-btn>
              </cube-upload>
            </div>
          </div>
          <div class="attention_">
            <img src="../../assets/image/yf/attention.png"
                 alt="二维码">
            <p>
              若是不当心选错照片，直接将正确的重新上传即可。上传照片格式为JPG
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="foot_">
      <p class="circle_" v-if="!isRead" @click="radioChange"></p>
      <img style="width: 9px;height: 9px;margin-top: 3px;" src="../../assets/image/yf/right.png" alt="" v-else @click="radioChange">
      <p>
        <span>本人已认证阅读并确认</span>
        <span @click="read"
              style="color: #E77371;font-size:11px;">《保险条款》</span>
        <span>的内容，充分了解并清楚知晓购买本保险产品的风险，愿意承担相关风险</span>
      </p>
    </div>
    <div class="btn" @click="appointment">
      确认预约
    </div>
    <div class="mask_bg"
         v-if="showMaskBg">
      <div class="read_box">
        <div class="close_"
             @click="close">
          <img src="../../assets/image/yf/close.png"
               alt="关闭">
        </div>
        <p class="read_item" @click="readMateriaContent">
          {{materialData.materialName}}
        </p>
        <div class="read_btn"
          @click="readComfirm">
          我已逐条阅读并同意
        </div>
      </div>
    </div>
    <div class="mask_bg" v-if="showContent" @click.self="showContent = false">
      <div class="agree_box">
        <div class="title">
          <span>{{materialData.materialName}}</span>
          <span class="close" @click="showContent = false"></span>
        </div>
        <div class="content">
          <div v-html="materialData.materialContent"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.app_page {
  background: #f6f7f9;
  padding: 24px 0;
  min-height: 100vh;
  .policy_info {
    background: #fff;
    padding-top: 22px;
  }
  .title_ {
    position: relative;
    height: 19px;
    font-size: 20px;
    font-family: PingFang SC;
    font-weight: 600;
    color: #292929;
    line-height: 36px;
    text-align: left;
    margin-left: 41px;
    margin-bottom: 25px;
    &::after {
      position: absolute;
      content: '';
      display: inline-block;
      width: 5px;
      height: 20px;
      background: #ff7b6f;
      border-radius: 2px;
      left: -10px;
      top: 8px;
    }
  }
  .item_ {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 65px;
    // line-height: 50px;
    color: #666;
    font-size: 15px;
    padding: 0 30px;
    border-bottom: 1px solid #f5f5f5;
    input {
      color: #666;
      font-size: 12px;
      text-align: right;
      &:focus {
        outline: none;
        border: none;
      }
      &.alert_ {
        &::-webkit-input-placeholder{
        color: #E66765;
      }
    }
    }
    .red_ {
      // width: 59px;
      padding: 0 11px;
      height: 18px;
      line-height: 18px;
      background: #fcdfe3;
      border-radius: 3px;
      color: #e66765;
      font-size: 12px;
    }
    .relate_item {
      display: inline-block;
      width: 50px;
      height: 18px;
      line-height: 18px;
      border-radius: 4px;
      font-size: 12px;
    }
    .grey_ {
      background: #ececec;
      color: #7e7e7e;
    }
    .active {
      background: #FCDFE3;
      color: #E66765;
    }
  }
  .insured_info {
    margin-top: 22px;
  }
  .benefic_info {
    margin-top: 34px;
  }
  .insurance_type_info {
    margin-top: 34px;
  }
  .id_card_info {
    margin-top: 24px;
    .id_card_upload_box {
      padding: 0 30px;
      .upload_ {
        display: flex;
        justify-content: space-between;
        .box_ {
          p {
            color: #666;
            font-size: 15px;
            margin-bottom: 6px;
          }
          .img_box {
            position: relative;
            width: 160px;
            height: 126px;
            display: flex;
            justify-content: center;
            flex-direction: column;
            margin: 0 auto;
            img.delete {
              position: absolute;
              top: 20px;
              right: 0;
              width: 20px;
              height: 20px;
              z-index: 100;
            }
          }
          img {
            width: 153px;
            height: 92px;
          }
        }
      }
      .attention_ {
        display: flex;
        margin-top: 10px;
        img {
          width: 9px;
          height: 9px;
          margin-right: 5px;
        }
        p {
          font-size: 9px;
          color: #e66765;
        }
      }
    }
  }
  .bottom_ {
    background: #fff;
    margin-top: 22px;
    padding-bottom: 17px;
  }
  .bank_card {
    margin-top: 11px;
    display: flex;
    justify-content: center;
    flex-direction: column;
    .img_box {
      position: relative;
      width: 140px;
      height: 100px;
      display: flex;
      justify-content: center;
      margin: 0 auto;
      img.delete {
        position: absolute;
        top: 0px;
        right: -2px;
        width: 20px;
        height: 20px;
        z-index: 100;
      }
      img.img_{
        margin-top: 5px;
        width: 131px;
        height: 94px;
      }
    }
    img {
      width: 131px;
      height: 94px;
    }
    p {
      color: #292929;
      font-size: 13px;
      font-weight: 600;
    }
  }
  .foot_ {
    display: flex;
    align-items: flex-start;
    color: #959494;
    font-size: 11px;
    padding: 0 30px;
    margin-top: 12px;
    margin-bottom: 20px;
    input {
      margin-top: 2px;
    }
    p {
      margin-left: 5px;
      text-align: left;
      line-height: 17px;
    }
    .circle_ {
      width: 14PX;
      height: 9PX;
      border: 1px solid #959494;
      border-radius: 50%;
      margin-top: 3px;
    }
  }
  .btn {
    font-size: 19px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #ffffff;
    line-height: 12px;
    width: 315px;
    height: 45px;
    line-height: 45px;
    background: #ff2322;
    border-radius: 15px;
    margin: 0 auto 17px;
  }
  .mask_bg {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100vh;
    background: rgba(0, 0, 0, 0.3);
    .agree_box {
      position: absolute;
      left: 0;
      bottom: 0;
      width: 100%;
      height: 500px;
      background: #fff;
      border-radius: 20px 20px 0px 0px;
      overflow-x: hidden;
      .title {
        color: #FF0000;
        height: 55px;
        line-height: 55px;
        font-size: 18px;
        font-family: PingFang SC;
        position: sticky;
        top: 0;
        background: #fff;
        z-index: 2;
        border-bottom: 1px solid #f5f5f5;
      }
      .close {
        position: absolute;
        top: 16px;
        right: 16px;
        display: inline-block;
        width: 18px;
        height: 18px;
        background: url('../../assets/image/yf/close.png') no-repeat center/18px 18px;
      }
      .content {
        padding: 0 20px;
        box-sizing: border-box;
        font-size: 13px;
        /deep/ p {
          text-align: left;
          line-height: 14px;
          font-size: 13px;
        }
        /deep/ img {
          max-width: 100%;
          height: auto;
        }
        /deep/ strong,
        /deep/ strong span{
          font-weight: bold;
        }
      }
    }
    .read_box {
      position: absolute;
      left: 0;
      bottom: 0;
      width: 100%;
      min-height: 222px;
      background: #fff;
      border-radius: 20px 20px 0px 0px;
      padding: 22px 30px 26px;
      .close_ {
        text-align: right;
        margin-bottom: 18px;
        color: #9d9d9d;
        img {
          width: 22px;
          height: 22px;
        }
      }
      .read_item {
        font-size: 12px;
        color: #e66765;
        text-align: left;
      }
      .read_btn {
        margin-top: 93px;
        width: 315px;
        height: 45px;
        background: #ff2322;
        border-radius: 15px;
        font-size: 19px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #ffffff;
        line-height: 45px;
      }
    }
  }
  .empty_ {
    text-align: right;
    font-size: 12px;
    margin-top: 7px;
  }
  .arrow_right {
    width: 16px;
    height: 16px;
  }
  .flex_ {
    display: flex;
    align-items: center;
  }
  .nowrap_ {
    white-space: nowrap;
  }
  .red_c {
    color: #E66765;
  }
}
</style>
<style lang="scss">
.cube-picker-wheel-item {
  white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 12px;
}
</style>

<script>
import compress from "../../components/compress"
import api from "@/utils/nsaleApi";
import checkIdCard from "@/utils/checkIdCard"
import sensorsEvent from '@/utils/sc.js';
import serviceQrCode from './components/serviceQrCode.vue'
const bankList = [
  { text: '工商银行', value: '工商银行'}, 
  { text: '北京银行', value: '北京银行' },
  { text: '农业银行', value: '农业银行' },
  { text: '建设银行', value: '建设银行' },
  { text: '兴业银行', value: '兴业银行' },
  { text: '交通银行', value: '交通银行' },
  { text: '浦发银行', value: '浦发银行' },
  { text: '中国银行', value: '中国银行' },
  { text: '光大银行', value: '光大银行' },
  { text: '邮政储蓄银行', value: '邮政储蓄银行' },
  { text: '招商银行', value: '招商银行' },
  { text: '广发银行', value: '广发银行' },
]
const cascadeData = []
const jobListData = []
export default {
  components: {
      serviceQrCode
    },
  data() {
    return {
      showMaskBg: false,
      bankFiles: [], // 文件列表
      policyFaceFiles: [],
      policyBackFiles: [],
      insuranceFaceFiles: [],
      insuranceBackFiles: [],
      fileSize: 0, // 
      relateList: [
        {
          value: 1,
          text: '本人'
        },
        {
          value: 2,
          text: '配偶'
        },
        {
          value: 3,
          text: '子女'
        },
        {
          value: 4,
          text: '父母'
        }
      ],
      activeRelateIndex: 0,
      isSelf: true,
      policyFormData: {
        // 投保人信息
        holderName: '', //投保人姓名
        idType: '1', //证件类型 1、身份证
        idNumber: '', //证件号码
        nationality: '中国', //国籍
        addressCode: '', //居住省市code
        addressName: '', //居住省市
        address: '', //详细地址
        postCode: '', //邮政编码
        telephone: '', //手机号
        email: '', //电子邮箱
        occupationCodeSh: '', //职业Code
        occupationNameSh: '', // 职业名称
        // 险种信息
        // productName: '', // 计划名称
        // productCode: '', // 计划code
        // paymentFreq: '年交', // 缴费频率
        premiumAmt: '', // 年交保费
        // 银行卡信息
        bankName: '', // 开户银行
        receiverName: '', // 持卡人姓名
        bankCardCode: '', // 银行卡号
        reservedPhone: '', // 预留手机号
        bankCardPicture: '', // 银行卡照片url
        // 身份证
        idCardFacePicture: '', // 证件正面照url
        idCardBackPicture: '', // 证件反面照url
        // 被保人信息
        offLineInsuredReqList: [],
        // 受益人信息
        offLineBeneficiaryReqList: [],
        mdProductCode: '',
        webUserId: '',
        weight: '',// 体重
        height: '',// 身高
        annualIncome: ''// 年收入
      },
      insuranceFormData: {
        beneficiaryType: null, // 受益人
        relationship: '1', // 投被保人关系1、本人2、配偶3、子女4、父母
        insuredName: '', //被保人姓名
        insuredIdType: '1', //被保人证件类型
        insuredIdNumber: '', //被保人证件号
        nationality: '中国', //国籍
        addressCode: '', //居住省市code
        addressName: '', //居住省市
        address: '', //详细地址
        postCode: '', //邮政编码
        telephone: '', //手机号
        email: '', //电子邮箱
        occupationCodeSh: '', //职业Code
        occupationNameSh: '', //职业名称
        idCardFacePicture: '', //证件正面照url
        idCardBackPicture: '', //证件反面照url
        weight: '',// 体重
        height: '',// 身高
        annualIncome: ''// 年收入
      },
      isRead: false,
      checkedData: {
        policyHolderName: false, //投保人姓名
        policyIdNumber: false, //证件号码
        policyAddressName: false, //居住省市
        policyAddress: false, //详细地址
        policyPostCode: false, //邮政编码
        policyTelephone: false, //手机号码
        policyEmail: false, //电子邮箱
        policyOccupationNameSh: false, //职业
        policyHeight: false, //身高
        policyWeight: false, // 体重
        policyIncome: false, // 年收入
        policyProductName: false, //缴费年限
        policyPremiumAmt: false, //年交保费
        bankName: false, //开户银行
        receiverName: false, //持卡人姓名
        bankCardCode: false, //银行卡号
        reservedPhone: false, //预留手机号

        insuredName: false, //被保人姓名
        insuredIdNumber: false, //被保人证件号码
        insuredAddressName: false, //被保人居住省市
        insuredAddress: false, //被保人详细地址
        insuredPostCode: false, //被保人邮政编码
        insuredTelephone: false, //被保人手机号码
        insuredEmail: false, //被保人电子邮箱
        insuredOccupationNameSh: false, //被保人职业
        insuredHeight: false, //身高
        insuredWeight: false, // 体重
        insuredIncome: false, // 年收入
      },
      provinceList: [], // 省份列表
      cityList: [], // 城市列表
      areaList: [],
      materialData: {},
      showContent: false,
      bankList,
      productInfoList: [],
      cascadeData,
      jobListData,
      productName: '',
      productCode: '',
      userId: '',
      policyIdPostCodePlaceHolder: '邮政编码不能为空',
      policyIdNumberPlaceHolder: '证件号不能为空',
      policyIdPhonePlaceHolder: '手机号码不能为空',
      policyIdEmailPlaceHolder: '电子邮箱不能为空',
      insurancePostCodePlaceHolder: '邮政编码不能为空',
      insuranceNumberPlaceHolder: '证件号不能为空',
      insurancePhonePlaceHolder: '手机号码不能为空',
      insuranceEmailPlaceHolder: '电子邮箱不能为空',
      reservedPhonePlaceHolder: '手机号码不能为空',
      isMainProduct: false,
      channelSystem: ''
    }
  },
  created() {
    this.materialData = JSON.parse(localStorage.getItem('materialData')) || {}
    let { productName,productCode,userId,channelSystem } = this.$route.query
    this.userId = userId
    this.productCode = productCode
    this.productName = productName
    this.channelSystem = channelSystem
    document.title = productName
    this.getAreas()
    this.getOccupation()
    this.fetchJsSdkSign()
    // 埋点
    let sensorsData = sessionStorage.getItem('sensorsData') ? JSON.parse(sessionStorage.getItem('sensorsData')) : {};
    sensorsEvent(sensorsData);
  },
  methods: {
    deleteImg(form, prop, table) {
      this[form][prop] = '';
      this[table] = [];
    },
    // deletepolicyFaceImg() {
    //   this.policyFormData.idCardFacePicture = '';
    //   this.policyFaceFiles = [];
    // },
    // deletepolicyFaceImg() {
    //   this.policyFormData.idCardFacePicture = '';
    //   this.policyFaceFiles = [];
    // },
    // jssdk
    fetchJsSdkSign() {
        const url = encodeURIComponent(location.href.split('#')[0])
        // alert('获取签名url ->' + url)
        api.getJsJdkSign({
          url
        }).then(async (data) => {
          const { appId, jssdkReqData } = data.data
          let options = {
            // debug: true,
            appId: appId, // 必填，公众号的唯一标识
            timestamp: jssdkReqData.timestamp, // 必填，生成签名的时间戳
            nonceStr: jssdkReqData.noncestr, // 必填，生成签名的随机串
            signature: jssdkReqData.signature, // 必填，签名，见附录1
            jsApiList: ['hideOptionMenu', 'showOptionMenu']
          }
          const { wxHideMenu } = await this.$wx.wxConfig(options)
          wxHideMenu()
        })
      },
    readMateriaContent() {
      this.showContent = true
    },
    getAreas() {
      api.getAreas().then(res => {
        this.cascadeData = res.data.data || []
      })
    },
    getOccupation() {
      api.getOccupation().then(res => {
        this.jobListData = res.data.data || []
      })
    },
    radioChange() {
      this.isRead = !this.isRead
      if (this.isRead) {
        this.showMaskBg = true
        this.materialContent = localStorage.getItem('materialContent')
      }
    },
    read() {
      this.showMaskBg = true
      this.materialContent = localStorage.getItem('materialContent')
    },
    readComfirm() {
      this.showMaskBg = false
      this.isRead = true
    },
    close() {
      this.showMaskBg = false
    },
    appointment() {
      if (!this.checkedValidData()) {
        return false
      }
      let params = {
        ...this.policyFormData,
        mdProductCode: this.productCode,
        webUserId: this.userId,
        offLineInsuredReqList: [{...this.insuranceFormData}]
      }
      console.log(params)
      api.offlineProductInfoSendEmail(params).then(res => {
        this.$router.push({
          path: '/productAppointmentSuccess',
          query: {
            userId: this.userId,
            productName: this.productName,
            channelSystem: this.channelSystem
          }
        })
      })
    },
    processFile(file, next) {
      compress(file, {
        compress: false
      }, next)
    },
    submitted(file,type,side){
      this.fileSize = file.size
      if (type == 'bankFiles') {
        let params = {
          image: file.base64,
          userId: this.$route.query.userId
        }
        this.uploadBankCard(params)
      } else {
        let params = {
          configure: {
            ignore_exif: true,
            side: ""
          },
          enable: false, // this.productCode == 'LBRSXLLZEZSS' ? false : true
          image: file.base64,
          userId: this.$route.query.userId
        }
        params.configure.side = side
        api.idCardVerify(params).then(res => {
          debugger
          if (res.data.returnCode != '0000') {
            if (type == 'policyFaceFiles' ) {
              this.policyFaceFiles = []
            } else if (type == 'policyBackFiles') {
              this.policyBackFiles = []
            } else if (type == 'insuranceFaceFiles') {
              this.insuranceFaceFiles = []
            } else {
              this.insuranceBackFiles = []
            }
            this.$toast('上传失败，请上传正确的照片格式！')
            return false
          } else {
            let url = res.data.data.imgUrl
            if (type == 'policyFaceFiles' ) {
              this.policyFormData.idCardFacePicture = url
            } else if (type == 'policyBackFiles') {
              this.policyFormData.idCardBackPicture = url
            } else if (type == 'insuranceFaceFiles') {
              this.insuranceFormData.idCardFacePicture = url
            } else {
              this.insuranceFormData.idCardBackPicture = url
            }
          }
        })
      }
    },
    uploadBankCard(data){
      api.uploadBankCard(data).then(res => {
        this.policyFormData.bankCardPicture = res.data.data
      })
    },
    errHandler(file) {
      // const msg = file.response.message
      this.$createToast({
        type: "warn",
        txt: "上传失败",
        time: 1000
      }).show();
    },
    changeRelate(index,item) {
      this.insuranceFormData.relationship = item.value
      this.activeRelateIndex = index
      this.isSelf = index === 0 ? true : false
      if (this.isSelf) {
        this.checkedData.insuredName = false
        this.checkedData.insuredIdNumber = false
        this.checkedData.insuredAddressName = false
        this.checkedData.insuredAddress = false
        this.checkedData.insuredPostCode = false
        this.checkedData.insuredTelephone = false
        this.checkedData.insuredEmail = false
        this.checkedData.insuredOccupationNameSh = false
        for (let k in this.insuranceFormData) {
          this.insuranceFormData[k] = ''
        }
        this.insuranceFormData = {
          ...this.insuranceFormData,
          beneficiaryType: null,
          relationship: '1',
          insuredIdType: '1',
          nationality: '中国'
        }
      }
    },
    showAddressPicker() {
      if (!this.mutiPicker) {
        console.log(this.provinceList);
        this.mutiPicker = this.$createCascadePicker({
          title: '',
          data: this.cascadeData,
          onSelect: this.selectHandle,
          alias: {
            value: 'code',
            text: 'name'
          },
        })
      }
      this.mutiPicker.show()
    },
    selectHandle(selectedVal, selectedIndex, selectedText) {
      this.checkedData.policyAddressName = false
      this.policyFormData.addressCode = selectedVal.join(',')
      this.policyFormData.addressName = selectedText.join(',')
    },
    showOccupationPicker() {
      if (!this.occupationPicker) {
        this.occupationPicker = this.$createCascadePicker({
          title: '',
          data: this.jobListData,
          onSelect: this.selectOccupationHandle,
          alias: {
            value: 'code',
            text: 'name'
          },
        })
      }
      this.occupationPicker.show()
    },
    selectOccupationHandle(selectedVal, selectedIndex, selectedText) {
      this.checkedData.policyOccupationNameSh = false
      this.policyFormData.occupationCodeSh = selectedVal[2]
      this.policyFormData.occupationNameSh = selectedText[2]
    },
    showInsuranAddressPicker() {
      if (!this.insuranPicker) {
        this.insuranPicker = this.$createCascadePicker({
          title: '',
          data: this.cascadeData,
          onSelect: this.selectInsuranHandle,
          alias: {
            value: 'code',
            text: 'name'
          },
        })
      }
      this.insuranPicker.show()
    },
    selectInsuranHandle(selectedVal, selectedIndex, selectedText) {
      this.checkedData.insuredAddressName = false
      this.insuranceFormData.addressCode = selectedVal.join(',')
      this.insuranceFormData.addressName = selectedText.join(',')
    },
    showInsuranOccupationPicker() {
      if (!this.insuranAddressPicker) {
        this.insuranAddressPicker = this.$createCascadePicker({
          title: '',
          data: this.jobListData,
          onSelect: this.selectInsuranOccupationHandle,
          alias: {
            value: 'code',
            text: 'name'
          },
        })
      }
      this.insuranAddressPicker.show()
    },
    selectInsuranOccupationHandle(selectedVal, selectedIndex, selectedText) {
      this.checkedData.insuredOccupationNameSh = false
      this.insuranceFormData.occupationCodeSh = selectedVal[2]
      this.insuranceFormData.occupationNameSh = selectedText[2]
    },
    showPayendyearPicker() {
      if (!this.payendyeaPicker) {
        this.payendyeaPicker = this.$createPicker({
          title: '',
          data: [this.productInfoList],
          onSelect: this.selectPayendyeaHandle,
          alias: {
            value: 'productCode',
            text: 'productNme'
          },
        })
      }
      this.payendyeaPicker.show()
    },
    selectPayendyeaHandle(selectedVal, selectedIndex, selectedText) {
      this.checkedData.policyProductName = false
      this.policyFormData.premiumAmt = this.productInfoList[selectedIndex].price
      this.checkedData.policyPremiumAmt = false
      this.policyFormData.productCode = selectedVal.join(',')
      this.policyFormData.productName = selectedText.join(',')
    },
    showBankPicker() {
      if (!this.bankPicker) {
        this.bankPicker = this.$createPicker({
          title: '',
          data: [bankList],
          onSelect: this.selectBankHandle,
        })
      }
      this.bankPicker.show()
    },
    selectBankHandle(selectedVal, selectedIndex, selectedText) {
      this.checkedData.bankName = false
      this.policyFormData.bankName = selectedVal.join(',')
      this.policyFormData.bankName = selectedText.join(',')
    },
    changeFieldName(e,fieldName) {
      let value = e.target.value
      console.log(value,'验证');
      this.checkedData[fieldName] = value ? false : true
      let emailReg = /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
      let telReg = /^1[3456789]\d{9}$/
      let postReg = /^\d{6}$/
      if (fieldName == 'policyPostCode') {
        if (postReg.test(this.policyFormData.postCode)) {
          this.checkedData.policyPostCode = false
        } else {
          this.policyIdPostCodePlaceHolder = '请填写正确的邮政编码'
          this.checkedData.policyPostCode = true
        }
      }
      if (fieldName == 'policyTelephone') {
        if  (telReg.test(this.policyFormData.telephone)) {
          this.checkedData.policyTelephone = false
        } else {
          this.policyIdPhonePlaceHolder = '请填写正确的手机号码'
          this.checkedData.policyTelephone = true
        }
      }
      if (fieldName == 'policyEmail') {
        if (emailReg.test(this.policyFormData.email)) {
          this.checkedData.policyEmail = false
        } else {
          this.policyIdEmailPlaceHolder = '请填写正确的电子邮箱'
          this.checkedData.policyEmail = true
        }
      }

      if (fieldName == 'insuredPostCode') {
        if (postReg.test(this.insuranceFormData.postCode)) {
          this.checkedData.insuredPostCode = false
        } else {
          this.insurancePostCodePlaceHolder = '请填写正确的邮政编码'
          this.checkedData.insuredPostCode = true
        }
      }
      if (fieldName == 'insuredTelephone') {
        if (telReg.test(this.insuranceFormData.telephone)) {
          this.checkedData.insuredTelephone = false
        } else {
          this.insurancePhonePlaceHolder = '请填写正确的手机号码'
          this.checkedData.insuredTelephone = true
        }
      }
      if (fieldName == 'insuredEmail') {
        if (emailReg.test(this.insuranceFormData.email)) {
          this.checkedData.insuredEmail = false
        } else {
          this.insuranceEmailPlaceHolder = '请填写正确的电子邮箱'
          this.checkedData.insuredEmail = true
        }
      }    
    },
    checkedValidData() {
      let flag = true
      let emailReg = /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
      if (!this.policyFormData.holderName) {
        flag = false
        this.checkedData.policyHolderName = true
      }
      if (!this.policyFormData.idNumber) {
        flag = false
        this.checkedData.policyIdNumber = true
      } else if (!checkIdCard(this.policyFormData.idNumber)) {
        flag = false
        this.checkedData.policyIdNumber = true
        this.policyIdNumberPlaceHolder = '请输入正确的证件号码'
      }
      if (!this.policyFormData.addressName) {
        flag = false
        this.checkedData.policyAddressName = true
      }
      if (!this.policyFormData.address) {
        flag = false
        this.checkedData.policyAddress = true
      }
      if (!this.policyFormData.postCode) {
        flag = false
        this.checkedData.policyPostCode = true
      }
      if (!this.policyFormData.telephone) {
        flag = false
        this.checkedData.policyTelephone = true
      } else if(!(/^1[3456789]\d{9}$/.test(this.policyFormData.telephone))) {
        this.policyIdPhonePlaceHolder = '请填写正确的手机号码'
        flag = false
        this.checkedData.policyTelephone = true
      }
      if (!this.policyFormData.email) {
        flag = false
        this.checkedData.policyEmail = true
      } else if(!(emailReg.test(this.policyFormData.email))){
        this.policyIdEmailPlaceHolder = '请填写正确的电子邮箱'
        flag = false
        this.checkedData.policyEmail = true
      }
      if (!this.policyFormData.occupationNameSh) {
        flag = false
        this.checkedData.policyOccupationNameSh = true
      }
      // if (!this.isMainProduct && !this.policyFormData.productName) {
      //   flag = false
      //   this.checkedData.policyProductName = true
      // }
      // if (!this.policyFormData.premiumAmt && this.policyFormData.premiumAmt !== 0) {
      //   flag = false
      //   this.checkedData.policyPremiumAmt = true
      // }
      if (!this.policyFormData.bankName) {
        flag = false
        this.checkedData.bankName = true
      }
      if (!this.policyFormData.receiverName) {
        flag = false
        this.checkedData.receiverName = true
      }
      if (!this.policyFormData.bankCardCode) {
        flag = false
        this.checkedData.bankCardCode = true
      }
      if (!this.policyFormData.reservedPhone) {
        flag = false
        this.checkedData.reservedPhone = true
      } else if(!(/^1[3456789]\d{9}$/.test(this.policyFormData.reservedPhone))) {
        this.reservedPhonePlaceHolder = '请填写正确的手机号码'
        flag = false
        this.checkedData.reservedPhone = true
      }
      if (!this.policyFormData.height) {
        flag = false
        this.checkedData.policyHeight = true
      }
      if (!this.policyFormData.weight) {
        flag = false
        this.checkedData.policyWeight = true
      }
      if (!this.policyFormData.annualIncome) {
        flag = false
        this.checkedData.policyIncome = true
      }
      // 利安人寿鑫利来增额终身寿险 LBRSXLLZEZSS 不用上传证件照和银行卡
      // if (!this.policyFormData.bankCardPicture && this.productCode != 'LBRSXLLZEZSS') {
      //   flag = false
      //   this.$toast('请上传银行卡照片')
      // }
      // if ((!this.policyFormData.idCardFacePicture || !this.policyFormData.idCardBackPicture) && this.isSelf && this.productCode != 'LBRSXLLZEZSS') {
      //   flag = false
      //   this.$toast('请上传证件照')
      // }
      // 如果被保人不是本人，还需要校验被保人信息
      if (!this.isSelf) {
        if (!this.insuranceFormData.insuredName) {
          flag = false
          this.checkedData.insuredName = true
        }
        if (!this.insuranceFormData.insuredIdNumber) {
          flag = false
          this.checkedData.insuredIdNumber = true
        } else if (!checkIdCard(this.insuranceFormData.insuredIdNumber)) {
          flag = false
          this.checkedData.insuredIdNumber = true
          this.insuranceNumberPlaceHolder = '请输入正确的证件号码'
        }
        if (!this.insuranceFormData.addressName) {
          flag = false
          this.checkedData.insuredAddressName = true
        }
        if (!this.insuranceFormData.address) {
          flag = false
          this.checkedData.insuredAddress = true
        }
        if (!this.insuranceFormData.postCode) {
          flag = false
          this.checkedData.insuredPostCode = true
        }
        if (!this.insuranceFormData.telephone) {
          flag = false
          this.checkedData.insuredTelephone = true
        } else if (!(/^1[3456789]\d{9}$/.test(this.insuranceFormData.telephone))) {
          flag = false
          this.checkedData.insuredTelephone = true
          this.insurancePhonePlaceHolder = '请输入正确的手机号码'
        }
        if (!this.insuranceFormData.email) {
          flag = false
          this.checkedData.insuredEmail = true
        } else if(!(emailReg.test(this.insuranceFormData.email))){
          this.insuranceEmailPlaceHolder = '请填写正确的电子邮箱'
          flag = false
          this.checkedData.insuredEmail = true
        }
        if (!this.insuranceFormData.occupationNameSh) {
          flag = false
          this.checkedData.insuredOccupationNameSh = true
        }
        if (!this.policyFormData.height) {
          flag = false
          this.checkedData.insuredHeight = true
        }
        if (!this.policyFormData.weight) {
          flag = false
          this.checkedData.insuredWeight = true
        }
        if (!this.policyFormData.annualIncome) {
          flag = false
          this.checkedData.insuredIncome = true
        }
        // if(this.productCode != 'LBRSXLLZEZSS') { // 利安人寿鑫利来增额终身寿险 LBRSXLLZEZSS 不用上传证件照和银行卡
        //   if (!this.policyFormData.idCardFacePicture || !this.policyFormData.idCardBackPicture
        //       || !this.insuranceFormData.idCardFacePicture || !this.insuranceFormData.idCardBackPicture) {
        //     flag = false
        //     this.$toast('请上传证件照')
        //   }
        // }
      }
      if (!this.isRead) {
        flag = false
        this.$toast('请阅读并勾选《保险条款》')
      }
      console.log(flag, 1352)
      return flag
    }
  }
}
</script>

